import { OfflineConstants } from '../offline/constants';
import { deleteStoreItem, getAllStoreItems, getStoreItem, getStoreKeys, putStoreItem } from '../offline/offlineApi';

export const getStowagePlanItem = async (key: string) => await getStoreItem(OfflineConstants.stores.stowage.storeName, key);
export const getAllStowagePlanItems = async () => await getAllStoreItems(OfflineConstants.stores.stowage.storeName);
export const putStowagePlanItem = async (storeItem: object, key: string) =>
    await putStoreItem(OfflineConstants.stores.stowage.storeName, storeItem, key);
export const deleteStowagePlanItem = async (key: string) => await deleteStoreItem(OfflineConstants.stores.stowage.storeName, key);
export const getStowagePlanKeys = async () => await getStoreKeys(OfflineConstants.stores.stowage.storeName);
